/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF1cWWhAYVJ/WmFZfVpgcF9GZ1ZSQmYuP1ZhSXxXdkxiW39acHNWQGFbV0A=');

platformBrowserDynamic().bootstrapModule(AppModule)
.catch(err => console.error(err));
